initScrollTop();
function initScrollTop() {
    var backToTop = $('#back-top');

    $(window).scroll(function () {
        if ($(this).scrollTop() > 220) {
            backToTop.fadeIn(400);
        } else {
            backToTop.fadeOut(400);
        };
    });

    backToTop.off('click.scrollTop').on('click.scrollTop', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('html, body').animate({
            scrollTop: 0
        }, 400);
        return false;
    });
}

if (window.innerWidth < 1140) {
  $(".AnnouncementBar__Wrapper.Dropdown-support").appendTo(".AnnouncementBar");
  $("#appendDropdown").html(document.querySelector(".Dropdown-support").outerHTML);
}

$(document).ready(function(){
    $("[data-collapse]").click(function(e){
        e.preventDefault();
        $(this).parents(".product__tab").toggleClass("is-active");
        $(this).parents(".product__tab").find(".rte").slideToggle(300);
    })
})

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(document).click(function(event) { 
  let $target = $(event.target);
  if(
    !$target.closest('#Search .stm-instant-search').length 
    && !$target.closest('#Search .Search__Input').length 
    && !$target.closest('[data-action="toggle-search"]').length 
    && !$target.closest('[data-action="close-search"]').length 
    && $('#Search .stm-instant-search').attr("aria-hidden") == "false"
    && $('#SearchMb .stm-instant-search').attr("aria-hidden") == "false"
  ) {
    $('#Search .stm-instant-search').attr("aria-hidden", "true");
  }
});